export default {
    show: function (message, hideDelay = 4500, showDelay = 500, selector = ".notification", cssClass = "") {
        let notificationClass = "notification",
            $notification = $(selector),
            $notificationMessage = $(`${selector} .notification__message`);

        // Show notification and then hide it after a delay
        setTimeout(() => {
            $notification.addClass(`${notificationClass}--visible`);
            if(cssClass.length>0) $notification.addClass(cssClass);
            $notificationMessage.html(message);
        }, showDelay);
        setTimeout(() => {
            $notification.removeClass(`${notificationClass}--visible`);
            if(cssClass.length>0) $notification.removeClass(cssClass);
            $notificationMessage.text(""); // remove text so that we can apply "disaply: none" on ".notification:empty"
        }, hideDelay);

    }
}



// WEBPACK FOOTER //
// ./js/notification/Notification.js